import {
  PublishParams,
  CompanyFields,
  CompanyListParams,
} from "../../view/Modules/Companies/CompanyDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const CompanyServices = {
  getCompanies: (params: CompanyListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.COMPANIES, {
        params,
      });
    }
    return AxiosInstance.get(ContentApiRoutes.COMPANIES, { params });
  },
  exportCompanies: (params: CompanyListParams) => {
    return AxiosInstance.get(ContentApiRoutes.EXPORT_COMPANIES, {
      params,
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "companies-export.xls");
      document.body.appendChild(link);
      link.click();
    });
  },
  createCompany: (data: CompanyFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_COMPANY, data),
  updateCompany: (id: number, data: CompanyFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_COMPANY.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  publishCompany: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_COMPANY.replace(":id", id.toString()),
      data
    ),

  publishBulkCompany: (ids: number[], data: PublishParams) =>
    AxiosInstance.put(ContentApiRoutes.PUBLISH_BULK_COMPANY, {
      ...data,
      ...{ ids: ids.toString() },
    }),

  deleteCompany: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_COMPANY.replace(":id", id.toString())
    ),

  deleteBulkCompany: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_BULK_COMPANY, idl);
  },

  viewCompany: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_COMPANY.replace(":id", id.toString())
    );
  },

  uploadLogo: (id: any, file: any) =>
    AxiosInstance.put(
      ContentApiRoutes.UPLOAD_COMPANY_LOGO.replace(":id", id.toString()),
      file
    ),

  searchCompanies: (company: string) =>
    AxiosInstance.get(ContentApiRoutes.COMPANIES + `?smart_search=${company}`),

  deleteCompanyLogo: (id: number) =>
    AxiosInstance.put(
      ContentApiRoutes.DELETE_COMPANY_LOGO.replace(":id", id.toString())
    ),
};
